import React, { forwardRef, useState, useImperativeHandle, useRef } from 'react'
import { Spin, Table } from 'antd'
import Select from 'meinian-package/src/baseComponent/select'
import Empty from 'meinian-package/src/baseComponent/empty'
import useAsyncLoading from 'common/hooks/useAsyncLoading'
import request from 'meinian-package/src/utils/request'
import cloneDeep from 'lodash/cloneDeep'
import styles from './index.module.less'

const columns = [
  {
    title: '排名',
    dataIndex: 'rank',
    align: 'center',
  },
  {
    title: '创建者',
    dataIndex: 'username',
    align: 'center'
  },
  {
    title: '今日采集数',
    dataIndex: 'todayCollect',
    align: 'center'
  },
  {
    title: '昨日采集数',
    dataIndex: 'yesterdayCollect',
    align: 'center'
  },
  {
    title: '总采集数',
    dataIndex: 'totalCollect',
    align: 'center'
  },
  {
    title: '已通过',
    dataIndex: 'passNum',
    align: 'center'
  },
  {
    title: '通过率',
    dataIndex: 'passPercent',
    align: 'center',
    render: (record) => {
      return `${record}%`
    }
  },
  {
    title: '已驳回',
    dataIndex: 'failNum',
    align: 'center'
  },
]

const sortOption = [{ value: 'yesterdayCollect', label: '按昨日采集数排序' }, { value: 'totalCollect', label: '按总采集数排序' }]

export default forwardRef(({ style, baseParams }, ref) => {
  const [sort, setSort] = useState('yesterdayCollect')
  const memberStatisticsData = useAsyncLoading({ fetchData: (_params) => fetchData(_params), params: baseParams })
  const paramsRef = useRef(null)
  paramsRef.current = sort

  const fetchData = async (_params) => {
    const __params = cloneDeep(_params)
    const result = await request.sget('/zhikuan/mn/collect-statistic/v2/member-statistic', __params, 'collect_statistic_member_statistic')
    result?.members?.sort((a, b) => b[paramsRef.current] - a[paramsRef.current])
    result?.members?.forEach((item, index) => {
      item.rank = index + 1 >= 10 ? index + 1 : `0${index + 1}`
    })
    return result
  }
  const _onChange = (val) => {
    memberStatisticsData.onUpdate({ ...baseParams, sort: val })
    setSort(val)
  }

  useImperativeHandle(ref, () => ({
    ...memberStatisticsData
  }))

  return (<div className={styles['meinian-member-statistics']} style={style}>
    <div className="meinian-member-statistics-header">
      <div className="meinian-member-statistics-title">成员统计</div>
      <div className="meinian-member-statistics-right">
        <Select allowClear={false} value={sort} data={sortOption} onChange={_onChange} displayStyle={{ maxWidth: 'unset' }} />
      </div>
    </div>
    <Spin spinning={memberStatisticsData.loading}>
      {
      memberStatisticsData.data?.members?.length ? <Table className="meinian-member-table" pagination={false} columns={columns} dataSource={memberStatisticsData.data?.members} /> : <Empty type="analysis" noPadding />
    }
    </Spin>
  </div>)
})
